import React, { useState } from "react";
import { EditableCellProps } from "../types/PriceTabTypes";

export const SimpleEditableCell: React.FC<EditableCellProps> = ({
  value,
  onChange,
  disabled = false,
  isLoading = false,
  fieldName = ''
}) => {
  const [localValue, setLocalValue] = useState(value?.toString() || '');
  const [isFocused, setIsFocused] = useState(false);

  // Define numeric fields for validation
  const numericFields = [
    'unitPurchasePrice',
    'unitPurchasePriceInc', 
    'unitPrice',
    'priceInc',
    'oldPriceInc',
    'markupPercent',
    'sellRangeMax',
    'sellRangeMin',
    'startingPrice',
    'quantity'
  ];

  const isNumericField = numericFields.includes(fieldName);

  // Update local value when external value changes
  React.useEffect(() => {
    setLocalValue(value?.toString() || '');
  }, [value]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    
    // For numeric fields, allow only numbers, decimal point, and negative sign
    if (isNumericField && newValue !== '') {
      const numericRegex = /^-?\d*\.?\d*$/;
      if (!numericRegex.test(newValue)) {
        return; // Don't update if invalid numeric input
      }
    }
    
    setLocalValue(newValue);
    // Immediately call onChange to update the global state
    onChange?.(newValue);
  };

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    setIsFocused(true);
    e.target.select();
  };

  const handleBlur = () => {
    setIsFocused(false);
    // Ensure the final value is saved when losing focus
    onChange?.(localValue);
  };

  const handleClick = (e: React.MouseEvent<HTMLInputElement>) => {
    e.currentTarget.select();
  };

  return (
    <div className="text-center">
      <input
        type="text"
        className="form-control form-control-sm"
        value={localValue}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onClick={handleClick}
        disabled={disabled || isLoading}
        style={{
          textAlign: 'center'
        }}
      />
    </div>
  );
};